export default {
	state: {
		sideBarOpen: false,
	},
	getters: {
		sideBarOpen: (state) => {
			return state.sideBarOpen;
		},
	},
	mutations: {
		toggleSidebar(state) {
			state.sideBarOpen = !state.sideBarOpen;
		},
		closeSidebar(state) {
			state.sideBarOpen = false;
		},
	},
	actions: {
		toggleSidebar(context) {
			context.commit("toggleSidebar");
		},
		closeSidebar(context) {
			context.commit("closeSidebar");
		},
	},
};
